export default {
      id: "title-aviation-usage",
      viewBox: "0 0 132 14",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#title-aviation",
      toString: function () {
        return this.url;
      }
    }